// Check for OS before setting env variables
// Assuming Unix
var isProduction = process.env.NODE_ENV === "production";
var isDevelopment = process.env.NODE_ENV === "development";
var isLocal = process.env.REACT_APP_IS_LOCAL;
var isStaging = process.env.REACT_APP_IS_STAGING;
var localUrl = process.env.REACT_APP_DOMAIN;

// If Windows
if (process.platform === "win32") {
  if (process.env.NODE_ENV) {
    console.log("Windows Environment");
    isProduction = process.env.NODE_ENV.replace(/\W/g, "") === "production";
    isDevelopment = process.env.NODE_ENV.replace(/\W/g, "") === "development";
  }
  // Deal with trailing whitespace in windows
  if (process.env.REACT_APP_IS_LOCAL) {
    isLocal = process.env.REACT_APP_IS_LOCAL.replace(/^\s+|\s+$/g, "");
  }

  if (process.env.REACT_APP_IS_STAGING) {
    isStaging = process.env.REACT_APP_IS_STAGING.replace(/^\s+|\s+$/g, "");
  }
}

// const NODE_ENV = process.env.NODE_ENV;
console.log("NODE_ENV: " + process.env.NODE_ENV);
const PROTOCOL = isProduction ? (isLocal ? "http://" : "https://") : "http://";

// npm run build > NODE_ENV=production
// npm run start > NODE_ENV=development
// "build:staging": "REACT_APP_IS_STAGING=true react-scripts build"
// "build:prod": "npm run build"
// "build:local": "REACT_APP_IS_LOCAL=true react-scripts build"

console.log("[1]REACT_APP_IS_STAGING: " + process.env.REACT_APP_IS_STAGING);
console.log("[1]REACT_APP_IS_LOCAL: " + process.env.REACT_APP_IS_LOCAL);

//const API_PORT = 3000;
const API_PORT = 3001;
const SERVER_URL = "localhost";

const API_URL = `${PROTOCOL}${SERVER_URL}:${API_PORT}`;

const jwtSecret = "sPvy5R1i6plu0FS2^$zvfobpTf&J2E3FOMBD!Qspi#bkjXej!2";
const GOOGLE_MAPS = "AIzaSyBCZOddsdk2hw8HhCi-fJv8j10YfcESUJk";

const MIMO_URL = "https://scscbackoffice.com";
const LOCAL_URL = localUrl;
const STAGE_URL = "https://staging.scscbackoffice.com";

const BASE_URL = (function() {
  if (isProduction === true) {
    console.log(
      "[2]process.env.REACT_APP_IS_STAGING: " + process.env.REACT_APP_IS_STAGING
    );
    if (isStaging === "true") {
      console.log(
        "[3]process.env.REACT_APP_IS_STAGING: " +
          process.env.REACT_APP_IS_STAGING
      );
      return STAGE_URL;
    } else if (isLocal === "true") {
      console.log(
        "[5]process.env.REACT_APP_IS_LOCAL: " + process.env.REACT_APP_IS_LOCAL
      );
      return LOCAL_URL;
    } else {
      console.log(
        "[4]process.env.REACT_APP_IS_STAGING: " +
          process.env.REACT_APP_IS_STAGING
      );
      return MIMO_URL;
    }
  } else {
    return API_URL;
  }
})();

console.log("API_URL: " + API_URL);
console.log("BASE_URL: " + BASE_URL);

// production and local > SCSCMain
// staging and development > SCSCMain_DEV
let db = (function() {
  // If staging or development
  if (isStaging || !isProduction) {
    return {
      server: "scscbackoffice-central.database.secure.windows.net",
      user: "scscadmin",
      password: "!12backoffice34!",
      database: "SCSCMain_DEV",
      requestTimeout: 0,
      port: 1433,
      options: {
        encrypt: true
      }
    };
  }
  // if local
  if (isProduction === true && isLocal === "true") {
    return {
      server: "SCSAFE-LP02",
      user: "sa",
      password: "rcmRCM1#",
      database: "SCSCMain",
      requestTimeout: 0,
      port: 1433,
      options: {
        encrypt: true
      }
    };
  }
  // default is SCSCMain
  return {
    server: "scscbackoffice-central.database.secure.windows.net",
    user: "scscadmin",
    password: "!12backoffice34!",
    database: "SCSCMain",
    requestTimeout: 0,
    port: 1433,
    options: {
      encrypt: true
    }
  };
})();

const MODEL_KEY = {
  ABIO: "100",
  SR7500: "300"
};

const AUTH_OPTIONS = () => {
  const token = localStorage.getItem("token");
  //const token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOjIzLCJpYXQiOjE1Mzg1NDcwNzQsImV4cCI6MTUzODU3NTg3NH0.xJGdabUgZw9_1KBx1TRDz1AnUOvqGOdfu-P_icgEs2s";
  const reqOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: token
    }
  };

  return reqOptions;
};

const cloudOrLocalController = isLocal ? 'LocalRcmControllers' : 'CloudRcmControllers'; 
const localLicenseRenewDate = isLocal? process.env.REACT_APP_LICENSE_RENEW_DATE : "";

module.exports = {
  jwtSecret,
  db,
  cloudOrLocalController,
  localLicenseRenewDate,
  isLocal,
  API_URL,
  GOOGLE_MAPS,
  BASE_URL,
  MODEL_KEY,
  AUTH_OPTIONS
};



// WEBPACK FOOTER //
// ./src/lib/config/index.js